import { createContext } from "react"

// Create a context to share mainDivRef between components
const MainDivRefContext = createContext(null)

export default MainDivRefContext
